import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, components } from '@/utils'

import button from '@/components/button'
import info from '@/components/info'

function renderBody(h) {
  return h(
    'div',
    { class: 'px-2' },
    [
      h(
        info,
        {
          props: {
            value: this.$_info,
            color: Colors.error
          }
        }
      )
    ]
  )
}
function renderFooter(h) {
  return h(
    'div',
    {
      class: 'dialog__footer',
      slot: 'footer'
    },
    [
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.close'),
            mode: buttonModes.flat
          },
          on: {
            click: () => {
              this.proxy = false
            }
          }
        }
      ),
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.confirm'),
            color: Colors.error
          },
          on: {
            click: () => {
              this.callback()
              this.proxy = false
            }
          }
        }
      )
    ]
  )
}

export default function(h) {
  let maxWidth
  if (this.viewport.breakpoint.mdUp) {
    maxWidth = 400
  }

  return h(
    components.dialog,
    {
      props: {
        value: this.proxy,
        title: this.$_title,
        maxWidth
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    },
    [
      renderBody.call(this, h),
      renderFooter.call(this, h)
    ]
  )
}
